/** Historic records without an event type are ordinary meetings. */
export function eventCategory(item: {eventType?: string}): 'meeting' | 'webinar' {
  return item.eventType === 'webinar' ? 'webinar' : 'meeting';
}
